export const OPEN_DURATION_MS = 180;
export const CLOSE_DURATION_MS = 120;
export const HOVER_TRANSITION_MS = 120;
export const MENU_OFFSET_Y = 4;
export const MENU_INITIAL_TRANSLATE_Y = -6;
export const MENU_INITIAL_SCALE = 0.97;
